import React from "react";
// import { Map } from "./Map";

export default function Amazing() {
  return (
    <div>
     <footer className="bg-white shadow-md p-5 mb-[-24px] " style={{ backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/group2.png)", backgroundSize: "cover" }}>
        <div class=" p-6 mx-auto">
          <div class=" lg:flex w-[100%]">
            <div class="w-full -mx-6 lg:w-[21%] ">
              <div class="px-6">
                <a href="/">
                  <img class="w-auto h-16" src="/images/logo.png" alt="" />
                </a>

                <p class="max-w-sm mt-2 text-white ">
                  Doha, Qatar
                </p>
                <p class="max-w-sm mt-2 text-white ">
                  <snap class="font-semibold text-white">Call us:</snap> 123-456-7890
                </p>
                <p class="max-w-sm mt-2 text-white ">
                  Terms of Use
                </p>
                <p class="max-w-sm mt-2 text-white ">
                  Privacy Policy
                </p>
                <p class="max-w-sm mt-2 text-white ">
                  Copyright @ 2022. DINERO <br /> all Rights Reserved
                </p>
              </div>
            </div>

            <div class="mt-6 lg:mt-0 lg:flex-1 ">
              <div class="grid grid-cols-2 gap-0 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
                <div>
                  <h3 class="text-white font-bold uppercase dark:text-white">
                    Our Products
                  </h3>
                  <ul>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    The Support Suite
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    The Sales Suite
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    Support
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    Guide
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    Explore
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    Connect
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white "
                  >
                    Integrations & Apps
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Product Updates
                  </li>
                  </ul>
                </div>

                <div>
                  <h3 class="text-white font-bold uppercase dark:text-white">
                    Top Features
                  </h3>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Ticketing System
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Knowledge Base
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Community Forums
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Help Desk Software
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Security
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Human Resources
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Media
                  </li>
                </div>

                <div>
                  <h3 class="text-white font-bold uppercase dark:text-white">
                    Recources
                  </h3>
                  <ul>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Product Support
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Request Demo
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Library
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Real Estate Blog
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Training
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Service & Partners
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Relate by Zendesk
                  </li>
                  <li
                    class="block mt-2 text-[13px] text-white"
                  >
                    Webinars
                  </li>
                  </ul>
                </div>

                <div>
                  <h3 class="text-white font-bold uppercase dark:text-white">
                    Company
                  </h3>
                  <span class="block mt-2 text-[13px] text-white">
                    About Us
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Press
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Investors
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Events
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Career
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Diversity & Inclusion
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Contact Us
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Sitemaps
                  </span>
                </div>
                <div>
                  <h3 class="text-white font-bold uppercase dark:text-white">
                    Favourite Things
                  </h3>
                  <span class="block mt-2 text-[13px] text-white">
                    For Enterprise
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    For Startups
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    For Benchmarks
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    For Small Business
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    CRM Quadrant
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Experiences
                  </span>
                  <span class="block mt-2 text-[13px] text-white">
                    Trends
                  </span>
                </div>
              </div>
            </div>
            <div>
              {/* <Map /> */}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
